import React from "react";
import { useParams } from "react-router";
import { useGet } from "../../api";
import { IMerchantSimple } from "../../interfaces";

export const MerchantView: React.FC = () => {
  const { _id } = useParams<{ _id: string }>();
  const { data: merchant } = useGet<IMerchantSimple>(`/merchants/${_id}`);

  return (
    <div>
      <p>Name: {merchant?.name}</p>
    </div>
  );
};
